import { render } from "./OrderUploadList.vue?vue&type=template&id=44bf2644"
import script from "./OrderUploadList.vue?vue&type=script&lang=js"
export * from "./OrderUploadList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__